import styled from "styled-components";

export const RefineWidgetPlaceholder = styled.div(({ theme }) => {
    return {
        height: "44px",
        width: "100%",
        marginTop: theme.spacing.x10,
        marginBottom: theme.spacing.medium,
    };
});
export const SortfilterWidgetPlaceholder = styled.div(({ theme }) => {
    return {
        height: "64px",
        marginLeft: theme.spacing.x8,
    };
});

export const RefineWidgetWrapper = styled.div<{
    sticky: boolean;
}>(({ theme }) => {
    return {
        display: "flex",
        alignItems: "center",
        height: "44px",
        width: "100%",
        cursor: "pointer",
        overflow: "auto",
        "scrollbar-width": "none",
        "-ms-overflow-style": "none",
        "&::-webkit-scrollbar": {
            display: "none",
            width: "0",
            background: "transparent",
        },

        "& > :first-child": {
            marginLeft: theme.spacing.x7,
        },
        "& > :last-child": {
            marginRight: theme.spacing.x7,
        },
    };
});

export const SortFilterWrapper = styled(RefineWidgetWrapper)(({ sticky, theme }) => ({
    ...(!sticky && {
        marginTop: theme.spacing.x10,
        marginBottom: theme.spacing.x11,
        backgroundColor: theme.colors[theme.colorMode].background_Secondary,
    }),
}));

export const RefineChipAnchorWrapper = styled.a`
    text-decoration: none;
    color: inherit;

    &:hover {
        text-decoration: none;
    }
`;

export const RefineChip = styled.div(({ theme }) => ({
    marginRight: theme.spacing.x5,
    whiteSpace: "nowrap",
}));

export const StyledButtonChip = styled.div<{ isSelected?: boolean }>(({ theme, isSelected }) => {
    return {
        borderRadius: 18,
        backgroundColor: !isSelected
            ? theme.colors[theme.colorMode].background_Primary
            : theme.colors[theme.colorMode].background_Tertiary,
        border: `1px solid ${
            isSelected
                ? theme.colors[theme.colorMode].border_Primary
                : theme.colors[theme.colorMode].border_Secondary
        }`,
        padding: `${theme.spacing.x4} ${theme.spacing.small}`,
        display: "inline-grid",
        width: "max-content",
        gridAutoFlow: "column",
        gridGap: theme.spacing.xSmall,
        ...(!isSelected && {
            boxShadow: "0px 2px 12px rgba(2, 6, 12, 0.04)",
        }),
        transition: "all 100ms ease-in",
    };
});

export const StyledButtonChipSpan = styled.span(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Button_Primary,
    color: theme.colors.light.background_Primary, // design needs the color to be the same for both color mode
    borderRadius: "50%",
    height: "19px",
    width: "19px",
    position: "relative",
    fontSize: "14px",
}));

export const InnerSpan = styled.span`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

export const SearchItemContainer = styled.div(({}) => ({
    width: "280px",
    flexShrink: "0",
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    marginRight: "10%",
}));

export const Wrapper = styled.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].background_Secondary,
    marginBottom: "0px",
    zIndex: "5",
}));
